import React from "react";
import ListItem from "../ListItem";
import styles from "./index.module.scss";
import Space from "components/Space";
import { AskListItem } from "../../../../../API/discuss";

interface AskListProps {
    data: AskListItem[];
    reload: () => void;
}

export default function AskList({ data, reload }: AskListProps) {
    return (
        <div className={styles.root}>
            <Space className={styles.list} direction="vertical" size={10}>
                {data.map(item => (
                    <ListItem key={item.uuid} data={item} reload={reload} />
                ))}
            </Space>
        </div>
    );
}
